//数组去重
export let arrReduce = (arr) => {
    let newArr = [];
    for( let i=0; i<arr.length; i++){
        if(arr.indexOf(arr[i]) === i){
            newArr.push(arr[i]);
        }
    }
    return newArr;  
}